export default __webpack_public_path__ + "static/media/welcome_to_dojo.57d72b68.md";